import { createContext, useContext } from 'react'

const PdfCollapsedContext = createContext<boolean>(false)

export const PdfCollapsedProvider = PdfCollapsedContext.Provider

export function useIsPdfCollapsed() {
  return useContext(PdfCollapsedContext)
}
